var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VSectionBar',{attrs:{"id":"q-and-a","message":"よくあるご質問"}}),_c('v-q-and-a-cards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }